"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentItemFactoryFromJS = exports.RecentItemFactory = exports.ButtonListItemFactoryFromJS = exports.ButtonListItemFactory = void 0;
const immutable_1 = require("immutable");
exports.ButtonListItemFactory = (0, immutable_1.Record)({
    id: null,
    title: null,
    icon: null,
    externalData: null
});
const ButtonListItemFactoryFromJS = function (data) {
    return (0, exports.ButtonListItemFactory)(data);
};
exports.ButtonListItemFactoryFromJS = ButtonListItemFactoryFromJS;
exports.RecentItemFactory = (0, immutable_1.Record)({
    id: null,
    title: null,
    description: null,
    time: null,
    icon: null,
    isPinned: false,
    hasPinCode: false,
    secretKey: null,
    projectSecretKey: null,
    externalData: null,
    _group: null
});
const RecentItemFactoryFromJS = function (data) {
    return (0, exports.RecentItemFactory)(data);
};
exports.RecentItemFactoryFromJS = RecentItemFactoryFromJS;
//# sourceMappingURL=entities.js.map